module.exports = __webpack_public_path__ + "media/images/pic/hero/work-160855039854a3037aedcc9e036105fd.webp";